import { useMutation, useQueryClient } from "react-query";
import { deleteDiagnostic } from "apps/diagnostics/api";

interface IDeleteDiagnosticParams {
  id: string;
}

export const useDeleteDiagnostic = (workspaceId: string) => {
  const queryClient = useQueryClient();
  return useMutation<unknown, Error, IDeleteDiagnosticParams>(
    (params: IDeleteDiagnosticParams) => deleteDiagnostic({ id: params.id }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["workspace-diagnostics", workspaceId]);
      },
    },
  );
};
